import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { CustomerServices } from '../../../../Services/CustomerServices';

const customerServices = new CustomerServices();

/** Options for the select; a saved value that is not in the list stays selectable. */
export const sectorOptionsWithValue = (options, value) => {
    if (!value || options.some(option => option.name === value)) return options;
    return [...options, { code: value, name: value, legacy: true }];
};

/**
 * Sector picker backed by `GET main/sectors`. Falls back to a free-text field while the
 * endpoint returns nothing, so existing behaviour is unchanged until the list ships.
 */
const SectorField = ({ value, onChange, label = 'Sector', error = false, helperText }) => {
    const [options, setOptions] = useState(null);

    useEffect(() => {
        let cancelled = false;
        customerServices.getSectors().then((rows) => {
            if (!cancelled) setOptions(rows);
        });
        return () => { cancelled = true; };
    }, []);

    if (!options || !options.length) {
        return (
            <TextField
                variant="outlined"
                fullWidth
                size="small"
                label={label}
                name="sector"
                value={value || ''}
                onChange={event => onChange(event.target.value)}
                error={error}
                helperText={helperText}
            />
        );
    }

    const list = sectorOptionsWithValue(options, value);
    return (
        <Autocomplete
            options={list}
            value={list.find(option => option.name === value) || null}
            getOptionLabel={option => option?.name || ''}
            getOptionSelected={(option, selected) => option.name === selected.name}
            autoHighlight
            onChange={(event, option) => onChange(option?.name || '')}
            renderInput={params => (
                <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    label={label}
                    error={error}
                    helperText={helperText}
                />
            )}
        />
    );
};

SectorField.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    error: PropTypes.bool,
    helperText: PropTypes.node,
};

export default SectorField;
